

















































import { Component, Vue } from "vue-property-decorator";
import { FileInUsePost, FileInUseTemplate } from "@/services/files/types";
import { Getter } from "vuex-class";
// role status
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";

const namespace: string = "authentication";

@Component
export default class FileDeleteNotAllowedModal extends Vue {
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
    fileUsedInPosts = [] as FileInUsePost[];
    fileUsedInTemplates = [] as FileInUseTemplate[];
    // role states
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;

    // methods
    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.fileUsedInPosts = [];
    }

    open(posts: FileInUsePost[], templates: FileInUseTemplate[]) {
        this.fileUsedInPosts = posts;
        this.fileUsedInTemplates = templates;
        this.$bvModal.show("modal-deleteFileNotAllowed");
        window.addEventListener("keydown", this.handleEnter);
    }

    close() {
        this.$bvModal.hide("modal-deleteFileNotAllowed");
    }

    TemplateRouteDetails(template: any) {
        if (template.templateType === "fixedhtml") {
            return {
                name: "updateFixedHtmlTemplate",
                params: { contentTemplateId: template.templateId }
            };
        } else if (template.templateType === "html") {
            return {
                name: "updateHtmlTemplate",
                params: { contentTemplateId: template.templateId }
            };
        }
    }
}
